"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = exports.EntityTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.EntityTypes = [
    // Order
    'sourgum-order',
    'wayste-order',
    // Invoice
    'sourgum-receivable',
    'sourgum-payable',
    'wayste-receivable',
    'wayste-payable',
    // Customer
    'sourgum-customer',
    'wayste-customer',
    'sourgum-lead',
    // Hauler
    'sourgum-vendor',
    // Pricing
    'sourgum-pricing-zone',
    'wayste-pricing-zone',
    // Disposal-Site
    'wayste-disposal-site',
    // Equipment (Dumpster)
    'wayste-dumpster',
    // Audit-Trail
    'audit-log',
    // Internal-Ticket
    'internal-ticket',
    // Product (Universal Services)
    'sourgum-invoice-grouping',
    'sourgum-rfp',
    // Commercial
    'wayste-commercial-subscription',
    'wayste-commercial-subscription-equipment',
    'wayste-commercial-route-plan-stop',
    'wayste-commercial-route-plan-template-stop',
    // Operations
    'operations-billing-period',
    'operations-order-item',
    'operations-order-commercial',
    'operations-order',
    'operations-subscription',
];
exports.EntityType = typebox_1.Type.Union(exports.EntityTypes.map((type) => typebox_1.Type.Literal(type)));
//# sourceMappingURL=entity-type.js.map